import React, { useState } from 'react';
import { Dropdown, Space, theme  } from 'antd';
import {
  DownOutlined
} from '@ant-design/icons';

const { useToken } = theme;

const CreateInvoiceOption = ({ activeModals, 
	showModal, 
	hideModal, ...props}) => {
	
	const { token } = useToken();

  	const menuOptions = [
		{
			key: 'monthly',
			label: 
				<a href={`/console/invoices/add?type=monthly`}>
					Monthly
				</a>
		},
		{
			key: 'selection_notice',
			label: 
				<a href={`/console/invoices/add?type=sn`}>
					Selection Notice
				</a>
		},
		{
			key: 'manual',
			label: 
				<a href={`/console/invoices/add?type=manual`}>
					Manual
				</a>
		},
	];

	const [dropdownOpen, setDropdownOpen] = useState(false);
	const contentStyle = {
	    backgroundColor: token.colorBgElevated,
	    borderRadius: token.borderRadiusLG,
	    boxShadow: token.boxShadowSecondary,
		zIndex: 999,
  	};
	const menuStyle = {
	    boxShadow: 'none',
  	};
	
  	return (
		  <div>
	    	<Dropdown
				open={dropdownOpen} 
	    		onOpenChange={setDropdownOpen}
	    		menu={{items: menuOptions}}
			  	dropdownRender={(menu) => (
			        <div style={contentStyle}>
						{React.cloneElement(menu, {
							style: menuStyle,
						})}			          
			        </div>
			      )}       		
	    	>
			    <div className="crud-button btn-small cursor-pointer">
					<Space>
						<span className="font-medium">Create</span>
						<DownOutlined />
					</Space>
			    </div>
		  	</Dropdown>
	  	</div>
  );
}

export default CreateInvoiceOption;
